// The shell's files plane (context.files). Records keep the platform shape
// `{ content: { src } }`; keys resolve like an Img `src: '/files/<key>'`.
import ambient from './ambient/index.js'

export default {
  ...ambient
}
